import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type GasSettingHeaderProps = {}

export const GasSettingHeader: React.FC<GasSettingHeaderProps> = () => {
  const { t } = useTranslation()
  return (
    <Root>
      <Label>{t('gas-settings.gas-option')}</Label>
      <Label>{t('gas-settings.time')}</Label>
      <Label>{t('gas-settings.max-fee')}</Label>
    </Root>
  )
}

const Root = styled.div`
  padding-block: 6px;
  padding-inline: 12px;

  display: grid;
  grid-template-columns: 1fr 0.8fr 1fr;
  border-bottom: 1px solid var(--backgroundA-2);
`

const Label = styled.div`
  color: var(--text-9);
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  &:last-child {
    justify-self: end;
  }
`
